//*react- recursos
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

//*interfaces
/* interface PropsRuta {
    ruta: any; 
  } */
  //store
  import rutaStore from "../../stores/ruta.store";
  //import archivaRuta from "../../archivar/archivaRuta/ArchivaRuta";

//*componente
export default function GeneraRuta() {
  //*api store
  //*store's
  const { setGeneraRuta,rutaArray} =
  rutaStore((state:any) =>( {
    setGeneraRuta: state.setGeneraRuta,
    rutaArray:state.rutaArray,
  }));  
  //*datos

  //*constantes y variables
  //*usestate

  //*useEffect
  
  //*funciones


  //*vista
  return (
    <>
      <label className="container">
        <div className="display-flex">
            { rutaArray.map((ru:any, indexru:any)=>
                <div key={indexru}><Nav.Link onClick={()=>setGeneraRuta(ru.ruta)}>{ru.ruta}/</Nav.Link></div>
            )}
        </div>
      </label>
    </>
  );
}
